/**
 * chatgpt/conversationApi.js — Sprint 1 refactor (2026-05-20)
 *
 * Trước: fetch sang `youteach.ai:5014/backend-api/v2/conversation` + REACT_APP_OPENAI_KEY.
 * Sau:   gọi POST /api/v1/llm-gateway/chat/stream với JWT, tool='chatgpt'.
 *
 * Backend gateway routing → Claude Haiku 4.5 (chat cheap).
 */

import { store } from 'store';
import apiSlice from 'store/slices/apiSlice';
import { streamChatLegacy, RateLimitError } from '../_shared/llmGateway';

const TOOL = 'chatgpt';

/**
 * Streaming chat qua LLM Gateway. Giữ chữ ký cũ (7 positional args + onEvent)
 * để App.js / chat component không phải sửa.
 *
 * @param {string} question
 * @param {string} [model]            DEPRECATED — gateway tự route
 * @param {string} [_apiKey]          DEPRECATED — không gửi client-side
 * @param {Object} [_selectedDocs]    Unused (chatgpt là pure chat)
 * @param {Array}  [history]
 * @param {string} [_conversationId]
 * @param {string} [_project]
 * @param {Function} onEvent
 * @param {Object}   [opts]
 * @param {AbortSignal} [opts.signal]
 * @param {string}      [opts.systemPrompt]
 */
export function fetchAnswerSteaming(
    question,
    model,
    _apiKey,
    _selectedDocs,
    history = [],
    _conversationId,
    _project,
    onEvent,
    opts = {}
) {
    return streamChatLegacy({
        tool: TOOL,
        question,
        history,
        model,
        systemPrompt: opts.systemPrompt,
        signal: opts.signal,
        onEvent,
    }).catch((e) => {
        if (e instanceof RateLimitError) {
            onEvent?.(new MessageEvent('message', { data: JSON.stringify({ type: 'error', detail: e.message, tool: TOOL, status: 429 }) }));
        }
        throw e;
    });
}

export async function sendFeedback(prompt, response, feedback) {
    const res = await store.dispatch(
        apiSlice.endpoints.postChatFeedback.initiate({
            question: prompt,
            answer: response,
            feedback,
            project: TOOL,
        })
    );
    if (res?.data !== undefined || res?.isSuccess) return Promise.resolve();
    return Promise.reject(new Error('sendFeedback failed'));
}
